import React from 'react';
import { motion } from 'framer-motion';
import { BONO_IMAGES } from '../lib/constants';
const bonuses = [{
  n: 'Bono 1',
  image: BONO_IMAGES.bono1,
  title: 'El Método “Nunca Más Te Quedes sin Lana”™',
  text: 'Calcula antes de empezar si el material que tienes realmente alcanza para terminar cualquier proyecto.',
  price: '$17 USD'
}, {
  n: 'Bono 2',
  image: BONO_IMAGES.bono2,
  title: 'La Fórmula de las Combinaciones Perfectas',
  text: 'Más de 300 combinaciones de colores para que cualquier tejido luzca elegante y profesional.',
  price: '$19 USD'
}, {
  n: 'Bono 3',
  image: BONO_IMAGES.bono3,
  title: 'El Método “Termina Todo lo que Empiezas”™',
  text: 'Recupera proyectos olvidados y conviértelos en prendas terminadas de las que te sentirás orgullosa.',
  price: '$21 USD'
}, {
  n: 'Bono 4',
  image: BONO_IMAGES.bono4,
  title: 'La Biblioteca Secreta de los 100 Proyectos',
  text: 'Ideas organizadas para que nunca vuelvas a quedarte sin inspiración.',
  price: '$19 USD'
}, {
  n: 'Bono 5',
  image: BONO_IMAGES.bono4,
  title: 'Teje para Regalar… o para Ganar Dinero',
  text: 'Descubre qué tejidos tienen mayor demanda y cómo convertir tu hobby en ingresos extra.',
  price: '$21 USD',
  noImage: true
}];
export function Bonuses() {
  return <section className="w-full bg-plum px-4 py-14" data-id="element-53" data-mp="3n79apnafx7at">
      <div className="mx-auto max-w-3xl text-center" data-id="element-54" data-mp="2zglri5v2qv8y">
        <h2 className="font-display text-2xl font-black leading-tight text-white sm:text-4xl" data-id="element-55" data-mp="2zhez191uxos5">
          🎁 5 Bonos Exclusivos
        </h2>
        <p className="mt-3 text-sm font-semibold text-mauve-soft sm:text-base" data-id="element-56" data-mp="38hbjszl4m3hx">
          Valorados en $97 USD — Incluidos{' '}
          <span className="text-white" data-id="element-57" data-mp="33fuk37edon2x">GRATIS</span> con tu compra de hoy
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-58" data-mp="noggn9jmbjuk">
        {bonuses.map((b, i) => <motion.div key={b.n} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-lg" data-id="element-59" data-mp="iqorgnacybu2" data-mpi={i}>
            <div className="flex items-center gap-2 bg-mauve px-4 py-2 text-sm font-extrabold text-white" data-id="element-60" data-mp="3qiflofowkwcz">
              <span data-id="element-61" data-mp="2tsyj49l7vqfi">🎁</span> {b.n}
            </div>
            {!b.noImage && <div className="bg-cream-2 p-3" data-id="element-62" data-mp="2xu0cwawd7aa3">
                <img src={b.image} alt={b.title} className="mx-auto h-40 w-auto object-contain drop-shadow-md" data-id="element-63" data-mp="2xutllhevw9uv" />
              </div>}
            <div className="flex flex-1 flex-col p-5" data-id="element-64" data-mp="37l4nyzix6azn">
              <h3 className="font-display text-base font-bold leading-snug text-plum" data-id="element-65" data-mp="2a57metyihumv">
                {b.title}
              </h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-plum/75" data-id="element-66" data-mp="2f1y05amuge54">
                {b.text}
              </p>
              <p className="mt-3 text-sm font-extrabold" data-id="element-67" data-mp="27hx44w2pxs1x">
                <span className="text-plum/40 line-through" data-id="element-68" data-mp="22ly9iqqsrdt2">{b.price}</span>{' '}
                <span className="text-sage" data-id="element-69" data-mp="1xl29wpdhadtg">→ GRATIS</span>
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}